export default {
  SET_HEADER_LAYOUT(state, value) {
    state.layout.header = value
  },

  SET_NAVBAR_OPEN(state, value) {
    state.layout.navbarOpen = value
  },
  // Topかどうか知る
  SET_ISTOP(state, value) {
    state.layout.isTop = value
  },
  // 200pxスクロール
  updateScroll200(state, value) {
    state.layout.scroll.scroll200 = value
  },
  updateStoreLoading(state, _payload) {
    state.layout.loading = _payload
  },
}
